/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popClaimOrders.vue?vue&type=template&id=237473a9&scoped=true"
import script from "./popClaimOrders.vue?vue&type=script&lang=js"
export * from "./popClaimOrders.vue?vue&type=script&lang=js"
import style0 from "./popClaimOrders.vue?vue&type=style&index=0&id=237473a9&prod&lang=scss&scoped=true"
import style1 from "./popClaimOrders.vue?vue&type=style&index=1&id=237473a9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237473a9",
  null
  
)

export default component.exports